import type { Locale } from "@/lib/i18n";
import { pl, type CookieConsentTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cookieConsentTranslations: Record<Locale, CookieConsentTranslations> = {
  pl,
  en,
  de,
};

export type { CookieConsentTranslations };
